import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import CreateCommonComponent from '@components/common/CreateComponent';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import { roleDetails } from '@constants/index';
import './CreateNewRole.css'
import { getData, getDataWithCache, postDataJSON } from '../../../services/CommonApiService';
import endpoints from '@config/endpoints';
import PrivilegeDetails from '../PrivielegeDetails';
import { useDispatch, useSelector } from 'react-redux';
import { updateForm } from '@store/actions/userManagementAction';
import { RootState } from '@store/reducers';
import { toast } from 'react-toastify';
import Auth from "../../../utils/auth";
import { errorLogger } from '@utils/applicationLogUtils';

interface objectTypes {
    isError: boolean,
    message: string,
    isDisable: boolean,
    value: any,
    id?: any,
    verifiedDetails?: any
    code?: number
}

interface formDataType {
    [key: string]: any;
}

interface formStateType {
    [key: string]: objectTypes
}

const CreateNewRole = ({ page, flow }: any) => {
    const newRoleObj = {
        user_type: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id: '',
            code: undefined
        },
        role_name: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id: '',
            code: undefined
        },
        user_designation: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id: '',
            code: undefined
        },
        status: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id: '',
            code: undefined
        },
        description: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
            id: '',
            code: undefined
        },

    }
    const navItemsModal = [
        'User Role Details',
        'Privilege Details'
    ];
    const navs = 100 / navItemsModal.length;

    const [newRoleData, setNewRoleData] = useState<formDataType>(roleDetails);
    const [newRoleForm, setNewRoleForm] = useState<formStateType>(newRoleObj);
    const [selectPerc, setSelectedPerc] = useState<any>(0);
    const [formCompleted, setFormCompleted] = useState<boolean[]>(Array(navItemsModal.length).fill(false));
    const [closeModal, setCloseModal] = useState<boolean>(false)
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [roleData, setRoleData] = useState<any>([]);
    const [roleDetail, setRoleDetail] = useState<any>();
    const role_payload = useSelector((state: RootState) => state.user.role_payload);
    const userId = localStorage.getItem('userId');

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const userTypeId = localStorage.getItem('userTypeId');
        getUserType(userTypeId);
        fetchRoles();
        dispatch(updateForm("edit_privilege_flow", true));

        return() => {
            dispatch(updateForm("edit_privilege_flow", false))
        }
    }, [])

    const getUserType = async (userTypeId: any) => {
        const usertypes = await getDataWithCache<any[]>(`${endpoints.getAllUserTypes}/${userTypeId}`)
        const usertypesOptions = usertypes.data.map((key: any) => ({
            value: key.usertype_name,
            label: key.usertype_name,
            id: key.usertype_id,
            code: key.usertype_code,
        }));
        const statusOptions = [
            {
                value: "Enabled",
                label: "Enabled",
                id: undefined,
                code: undefined,
            },
            {
                value: "Disabled",
                label: "Disabled",
                id: undefined,
                code: undefined,
            }]
        setNewRoleData((role_details: any) => ({
            ...role_details,
            user_type: {
                ...role_details.user_type,
                '#options': usertypesOptions,
            },
            status: {
                ...role_details.status,
                '#options': statusOptions
            }
        }))
    }
    const breadcrumbItemName = [
        { value: page, label: 'User Management' },
        { value: page, label: 'Create Role' },
    ];

    const onHandleBackArrowButton = () => {
        navigate(`/user-management/role`);
    };


    function handlePrevious(): void {
        setActiveIndex((prevState: number) => prevState - 1)
        const newFormCompleted = [...formCompleted];
        newFormCompleted[activeIndex] = false;
        newFormCompleted[activeIndex - 1] = false;
        setFormCompleted(newFormCompleted);
        const perc = (activeIndex - 1) * navs;
        setSelectedPerc(perc);
    }

    const finishHandler = async () => {
        const newRolePrivilegesPayload = {
            userTypeId: newRoleForm.user_type.id,
            roleId: newRoleForm.role_name.id,
            userDesignationId: newRoleForm.user_designation.id,
            userStatus: newRoleForm.status.value === 'Enabled',
            description: newRoleForm.description.value,
            privilegeId: role_payload,
            parentUserId:userId
          };

          await postDataJSON(
            `${endpoints.createUserRole}`,
            newRolePrivilegesPayload,
          );

          toast.success('Role have been successfully created', {
            position: 'top-center',
          });
        navigate("/user-management/role"); 
    }

    function handleNext(): void {
        if (activeIndex < navItemsModal.length - 1) {
            setActiveIndex(activeIndex + 1);
        } else if (activeIndex === navItemsModal.length - 1) {
            setSelectedPerc(selectPerc + navs);
        }
    }

    function closeCreateModal(value: boolean): void {
        if (value) {
            navigate("/user-management/role");
        }
        else {
            setCloseModal(false);
        }
    }

    const handleFormChange = async (value: any, key: string, id?: any, option?: any, code?: any, field?: formDataType | undefined) => {
        if (value && key === "user_type") {
            if (id) {
                const userDesignation = await getData<any[]>(`${endpoints.getUserDesignation}/${id}`)
                const userDesignationOptions = userDesignation.data.map((key: any) => ({
                    value: key.user_designation_name,
                    label: key.user_designation_name,
                    id: key.user_designation_id,
                    code: key.user_designation_code,
                }));

                setNewRoleData((role_details: any) => ({
                    ...role_details,
                    user_designation: {
                        ...role_details.user_designation,
                        '#options': userDesignationOptions
                    },
                }))

                setNewRoleForm((prevState: any) => ({
                    ...prevState,
                    user_designation: {
                        ...prevState.user_designation,
                        value: '',
                        id: '',
                        code: '',
                    },
                }));
            }
        }
        if(!value && key === "user_type") {
            setNewRoleData((role_details: any) => ({
                ...role_details,
                user_designation: {
                    ...role_details.user_designation,
                    '#options': []
                },
            }))

            setNewRoleForm((prevState: any) => ({
                ...prevState,
                user_designation: {
                    ...prevState.user_designation,
                    value: '',
                    id: '',
                    code: '',
                },
            }));        
        }
        if(key === 'description' && value.length > 30){
            return;
        }
        if((key === 'user_type') || (key === 'user_designation')){
            setNewRoleForm((prevState: any) => ({
                ...prevState,
                role_name: {
                  ...prevState.role_name,
                  isError: false,
                },
              }));
        }
        setNewRoleForm((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                isError: false,
                message: '',
                id: id,
                code: code,
            },
        }));
    }

    const fetchRoles = async () => {
        try{
        const rolesResponse = await getDataWithCache<any[]>(`${endpoints.getRoles}`);
        setRoleData(rolesResponse.data);
          const userRoleOptions = rolesResponse.data?.map((key: any) => (
            {
                value: key.role_name,
                label: key.role_name,
                id: key.role_id,
                code: key.role_code,
            }
        ))

        setNewRoleData((role_details: any) => ({
            ...role_details,
            role_name: {
                ...role_details.role_name,
                '#options': userRoleOptions,
            }
        }))
        }
        catch(err: any){
            throw new err(err);
        }
    }

    const handleRoleSave = async () => {
      try {
        
        if (activeIndex === 0) {
          let checkError = false;
          if (!newRoleForm.user_type.value) {
            setNewRoleForm((prevState: any) => ({
              ...prevState,
              user_type: {
                ...prevState.user_type,
                isError: true,
                message: 'User Type cannot be blank. Select valid User Type.',
              },
            }));
            checkError = true;
          }
          if (!newRoleForm.user_designation.value) {
            setNewRoleForm((prevState: any) => ({
              ...prevState,
              user_designation: {
                ...prevState.user_designation,
                isError: true,
                message:
                  'User Type cannot be blank. Select valid User Designation.',
              },
            }));
            checkError = true;
          }
          if (!newRoleForm.status.value) {
            setNewRoleForm((prevState: any) => ({
              ...prevState,
              status: {
                ...prevState.status,
                isError: true,
                message: 'Status cannot be blank. Select valid status.',
              },
            }));
            checkError = true;
          }
          if (!newRoleForm.role_name.value) {
            setNewRoleForm((prevState: any) => ({
              ...prevState,
              role_name: {
                ...prevState.role_name,
                isError: true,
                message: 'User Role cannot be blank. Select valid User Role.',
              },
            }));
            checkError = true;
          }

          const id1 = newRoleForm.user_type.id;
          const id2 = newRoleForm.user_designation.id;
          const id3 = newRoleForm.role_name.id;
          const payload = {user_type: id1, user_designation: id2, role_name: id3};
          const isRoleExistResponse = await postDataJSON<any[]>(
            `${endpoints.getUserRoleExist}`,payload
          );
          const isDuplicate = isRoleExistResponse.data[0].check_composite_role_exists;
          if (isDuplicate) {
            setNewRoleForm((prevState: any) => ({
              ...prevState,
              role_name: {
                ...newRoleForm['role_name'],
                isError: true,
                message:
                  'This role alreay exists, please select a different role.',
              },
            }));
            const newFormCompleted = [...formCompleted];
            newFormCompleted[activeIndex] = false;
            setFormCompleted(newFormCompleted);
            setSelectedPerc(0);
            return;
          }

          if (!checkError) {
            const currRoleDetail = {
                "user_type": newRoleForm.user_type.value,
                "role_name": newRoleForm.role_name.value,
                "user_designation": newRoleForm.user_designation.value,
                "status": newRoleForm.status.value,
                "description": newRoleForm.description.value
            }
            setRoleDetail(currRoleDetail);
            const newFormCompleted = [...formCompleted];
            newFormCompleted[activeIndex] = true;
            setFormCompleted(newFormCompleted);
            const perc = (activeIndex + 1) * navs;
            setSelectedPerc(perc);
          }
        } else if (activeIndex === 1) {
          if (!Object.keys(role_payload).length) {
            dispatch(updateForm("isPrivilegeSelected", false));
            const newFormCompleted = [...formCompleted];
            newFormCompleted[activeIndex] = false;
            setFormCompleted(newFormCompleted);
            const perc = (activeIndex) * navs;
            setSelectedPerc(perc);
            const element = document.body.getElementsByClassName("privilege")[0];

            if(element) {
                element.scrollIntoView({
                    behavior:"smooth",
                    block:"start"
                })
            }
            return;
          }
          
          const newFormCompleted = [...formCompleted];
          newFormCompleted[activeIndex] = true;
          setFormCompleted(newFormCompleted);
          const perc = (activeIndex + 1) * navs;
          setSelectedPerc(perc);
          dispatch(updateForm("isPrivilegeSelected", true));
        }
      } catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    };

    const handleCancel = () => {
        setCloseModal(true);
    }

    const handleNavClick = (index: number): void => {
        if (formCompleted[index]) {
            setActiveIndex(index);
        }
    };

    const contents = [
        <>
            <div className="create_new_role">
                <form className="role_form_container">
                    <CommonFormFields
                        formData={newRoleData}
                        formState={newRoleForm}
                        handleFormChange={handleFormChange}
                    />
                </form>
            </div>
        </>,
        <>
        <PrivilegeDetails flow={flow} page={page} roleDetails={roleDetail}/>
        </>
    ];

    return (
        <>
            <div className="new-role-container">
                <CreateCommonComponent
                breadcrumbItemName={breadcrumbItemName}
                onHandleBackArrowButton={onHandleBackArrowButton}
                navItemsModal={navItemsModal}
                activeIndex={activeIndex}
                handleNavClick={handleNavClick}
                formCompleted={formCompleted}
                headerName={"Create a new User Role"}
                progressBarPerc={selectPerc}
                contents={contents}
                handlePrevious={handlePrevious}
                handleSubmit={handleRoleSave}
                finishHandler={finishHandler}
                handleNext={handleNext}
                handleCancel={handleCancel}
                closeCreateModal={closeCreateModal}
                closeModal={closeModal}
                />
            </div>
        </>
    )
}

export default CreateNewRole